import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from '../../../shared/utilities/Constants';
import { OptionDropdown, SelectControl } from '../../../create-request/models/OptionDropdownSelect';
import { createControl } from '../../../create-request/utilities/formUtilities';

@Component({
  standalone: false,
  selector: 'mm-sa-ach-contribution-reason',
  templateUrl: './sa-ach-contribution-reason.component.html',
  styleUrls: ['./sa-ach-contribution-reason.component.scss']
})
export class SaAchContributionReasonComponent implements OnInit, OnDestroy {

  @Input() parentForm: UntypedFormGroup;
  @Input() contributionOptions$: Observable<string[]>;
  @Input() contributionReason$: Observable<string[]>;
  readonly formControlName: string = 'contributionReason';
  contributionModel$: Observable<SelectControl>
  tooltipVerbiage: string = Constants.contributionYear;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    createControl(this.parentForm, this.formControlName, '', [Validators.required]);

    this.contributionModel$ = this.contributionOptions$.pipe(
      map((contributionOptions) => {
        return {
          title: 'Contribution year',
          controlName: this.formControlName,
          options: this.mapContributionOptions(contributionOptions),
          validationMessage: 'Contribution year is required.'
        };
      })
    )
    this.parentForm.controls.contributionReason.disable();
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl(this.formControlName);
  }

  mapContributionOptions(contributionOptions: string[]): OptionDropdown[] {
    return contributionOptions?.map(element => new OptionDropdown(element, element));
  }

  get contributionReason(): FormControl {
    return this.parentForm?.get(this.formControlName) as FormControl;
  }

}